export enum SalesOpportunityStatusEnum {
  CREATED = 1,
  CONTACT = 2,
  OFFER = 3,
  MEETING = 4,
  ACCEPTED = 5,
  CANCELED = 6,
  OPPORTUNITY = 7
}
